@import '../../theme/colors';

.menu {
  border-bottom: 1px solid $neutral-200;
  padding: 0;
  margin: 0;

  .menuItem {
    text-decoration: none;
    position: relative;
    border-top: 1px solid $neutral-200;
    color: #ffffff;
    font-family: var(--font-family__heading);
    font-size: 18px;
    align-items: center;
    height: 80px;
    padding: 13px 13px 13px 19px;
    display: flex;
    flex-direction: row;
    box-sizing: border-box;
    text-transform: uppercase;
  }

  .menuItemIcon {
    font-size: 35px;
  }
  .menuItemLabel {
    margin-left: 12px;
  }

  .active {
    background-color: #fff;
    color: #4f4f4f;
    border-left: 0;

    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: -1px;
      height: calc(100% + 2px);
      width: 8px;
      background-color: $neutral-500;
      z-index: 10;
    }
  }
}
